// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../shared/images/Chat/Close_chatPanel_button.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../shared/images/Chat/send_button.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../shared/images/Chat/ScrollDown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    padding: 0 1rem;
    position: relative;
}

.chat-container__message-item-container {
    width: 90%;
    max-width: 90%;
    display: inline-block;
    position: relative;
}

.chat-container__message-item-container * {
    font-family: Gilroy !important;
    font-weight: 500;
}

/*discard font rule for all tags inside*/
.wmde-markdown * {
    font-weight: revert;
}

.chat {
    width: 98%;
    height: 100%;
    background: white;
    overflow: auto;
}

.silent-chat-wrap {
    width: 2.7rem;
    height: 2.7rem;
    cursor: pointer;
}

.chat-container__opertator_text-input-container {
    display: block;
    width: 100%;
}

.chat-container__opertator_text-input-container td{
    text-align: center;
}

.operator-text-input__table {
    margin-top: 1rem;
}

.operator-text-input_line td {
    vertical-align: bottom;
}

.operator-text-input_line {
    display: table-row;
    vertical-align: inherit;
}

.operator-text-input__table tr {
    border-bottom: 0rem;
}

.operator-text-input__table td {
    padding: 0;
    margin: 0;
}

.chat-container__opertator_menu {
    max-height: 10rem;
    word-break: break-all;
    word-break: break-word;
    border: 1rem solid transparent;
}

.chat-container__opertator_menu td{
    text-align: center;
    padding: 0rem;
    max-width: 22rem;
}

.chat-container__opertator_menu tr{
    border-bottom: 0rem;
}

.contact-avatar-container {
    /* display: flex; */
    position: relative;
    width: 5rem;
    min-width: 5rem;
    vertical-align: top;
}

.contact-avatar-holder {
    position: absolute;
    top: 3.5rem;
    right: 8.5rem;
}

.contact-item__contact-avatar {
    display: block !important;
    width: 3.6rem;
    height: 3.6rem;
    transform: none;
    margin: 0;
}

.contact-item__contact-avatar.offline {
    border: 2px solid #f00;
}

.contact-item__contact-avatar.online {
    border: 2px solid #0f0;
}

.contact-name-container {
    width: 30rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    margin-left:3rem;
}

.chat-history label {
    margin-right: 3rem;
}
    .chat-history > div {
        display: flex;
        align-items: center;
        justify-content: center;
    }

.close-chat-panel-button{
    right: 4rem;
    top: 1.5rem;
}

.hide-chat-panel-button{
    display: inline-block;
    float: left;
}

.chat-header-channel-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hide-chat-panel-button img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 3.6rem;
    border-radius: 50%;
    padding: 6px;
    margin-left: -0rem;
    cursor: pointer;
}

.hide-chat-panel-button img:hover {
    padding: 6px;
    border-radius: 50%;
    box-shadow: 0px 0px 2px 0px #000;
}

.contact-avatar-link {
    display: flex;
    justify-content: center;
    align-items: center;
}

.contact-avatar {
    border-radius: 50%;
    width: 4.8rem !important;
    height: 4.8rem !important;
    margin-left: -2.1rem;
    border: 12px solid green;
}

.contact-avatar svg {
    width: 100%;
    height: 100%;
}

.chat-name-container {
    white-space: nowrap;
}

.chat-container__file_loader {
    background-color: #fff;
    font-size: small;
    font-weight: 600;
    margin: 0 24px;
}

.operator-text-input {
    overflow: hidden;
    resize: none;
    width: 100%;
    border: none;
    border-bottom: #9e9e9e solid 1px;
    background-color: transparent;
    border-radius: 0;
    outline: none;
    font-size: 1.8rem !important;
    margin: 0rem 0 0rem 0;
    padding: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
}

.client-tags-container {
    width: 30rem;
}

.operator-text-input__table textarea,
.operator-text-input__table textarea:hover,
.operator-text-input__table textarea:focus {
    font-size: initial;
    border: none !important;
    box-shadow: none !important;
    overflow-y: auto;
}

.chat-container__footer{
    position: relative;
}

.chat-footer__close-chat {
    background: none; 
    border: none; 
    box-shadow: none;
    padding: 0;
    margin: 0;
    text-transform: none;
    color: #039be5;
    font-size: 1.8rem;
    line-height: 1.8rem;
}

.chat-footer__close-chat:focus {
    background: none;
    color: #039be5;
}

.chat-footer {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 1.8rem;
    column-gap: 1rem;
    margin: 1rem 2rem;
}

.chat-footer tr {
    border: none;
}

.chat-footer button {
    cursor: pointer;
}

.search-answer-template-button {
    position: relative;
    right: -5px;
    bottom: -8px;
    opacity: 0.7;
    font-size: 2.9rem;
    cursor: pointer;
}

.search-answer-template-button:hover {
    opacity: 1;
}

.mic-button-recording {
    color: red;
    position:relative;
    right: 5px;
    bottom: -3px;
    opacity: 0.7;
    font-size: 22.5px;
    transition: opacity 1000ms ease-in-out;
}

.mic-button-recording:hover {
    cursor:pointer;
    opacity: 1;
}

.mic-button {
    position: relative;
    right: 5px;
    bottom: -5px;
    opacity: 0.7;
    font-size: 2.2rem;
}

.mic-button:hover{
    cursor:pointer;
    opacity: 1;
}

.send-button {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 3rem;
    vertical-align: middle;
    cursor: pointer;
    opacity: 0.7;
}

.send-button:hover {
    opacity: 1;
}

.chat__scroll-to-up-container {
    width: 3.6rem;
    height: 3.6rem;
    position: absolute;
    top: 18rem;
    right: 3.6rem;
    opacity: .3;
    background-color: rgb(215, 215, 215);
    border-radius: 50%;
}

.chat__scroll-to-bottom-container {
    width: 3.6rem;
    height: 3.6rem;
    position: absolute;
    bottom: 18rem;
    right: 3.6rem;
    opacity: .3;
    background-color: rgb(215, 215, 215);
    border-radius: 50%;
    z-index: 1;
}

.chat__scroll-to-up {
    position: relative;
    width: 70%;
    height: 80%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    margin-left: 15%;
    border-radius: 50%;
    transform: rotate(180deg)
}
 
.chat__scroll-to-bottom {
    position: relative;
    width: 70%;
    height: 80%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    margin-left: 15%;
    margin-top: 15%;
    border-radius: 50%;
}


.chat__scroll-to-bottom-container:hover {
    opacity: 0.9;
    cursor: pointer;
}

.chat__scroll-to-up-container:hover {
    opacity: 0.9;
    cursor: pointer;
}

.transfer-chat__open-operators {
    background: none;
    border: none;
    box-shadow: none;
    color: blue;
    text-transform: none;
    font-size: 1.8rem;
    text-align: center;
    width: 100%;
    padding: 0;
    float: left;
}

.transfer-chat__open-operators:hover {
    background: none;
    border: none;
    box-shadow: none;
}

.transfer-chat__open-operators:focus {
    background: none;
    border: none;
    box-shadow: none;
}

.chat-footer__transfer-chat {
    width: 100%;
}

.message-params {
    width: 3vh;
    padding-bottom: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.chat-footer td {}

.invite-operator {
    float: left;
}

.transfer-chat__dropdown-operators {
    position: absolute !important;
    will-change: transform !important;
    top: 10rem !important;
    left: 0px !important;
    transform: translate3d(116px, -286px, 0px) !important;
}

.transfer-chat__closed {
    display: none;
}

.transfer-chat__dropdown-header {
    display: flex;
    flex-direction: column;
    height: 5.4rem;
    margin: 0 0 1.8rem 0;
}

.transfer-chat__dropdown-operators .transfer-chat__dropdown-item:nth-of-type(odd) {
    background-color: rgb(255, 255, 255, 1);
}

.transfer-chat__dropdown-operators .transfer-chat__dropdown-item:nth-of-type(even) {
    background-color: rgba(200, 200, 200, 1);
}

.transfer-chat__transfer-btn {
    width: 7.2rem;
    height: 2.7rem;
    padding: 0;
    font-size: 1.8rem;
    box-shadow: none;
    border-radius: 0;
    margin: auto auto 1rem auto;
    line-height: 0;
}

.transfer-chat__dropdown-operators .dropdown-item {
    border: none;
    height: 6.3rem;
}

.transfer-chat__dropdown-operators .dropdown-item:focus {
    background-color: rgb(239, 239, 239) !important;
}

.transfer-chat__dropdown-operators .dropdown-item:hover {
    background-color: rgb(150, 150, 150) !important;
}

.transfer-chat__no-online-operators {
    color: black;
    text-align: center;
    height: 5.4rem;
}

.transfer-chat__search {
    margin: 0 0.4rem;
    margin-top: 0.2rem;
}

.transfer-chat__col {
    padding-left: 0;
    padding: 0;
}

.transfer-chat__dropdown-operators hr {
    width: 90%;
}

.transfer-chat__footer {
    display: flex;
    flex-direction: column;
    margin-top: auto;
}

.chat__export-chat-btn {
    background: none; 
    border: none; 
    box-shadow: none;
    padding: 0;
    margin: 0;
    text-transform: none;
    color: #039be5;
    font-size: 1.8rem;
    line-height: 1.8rem;
}

.chat__export-chat-btn:focus {
    background: none;
    color: #039be5;
}

.chat-container__scrollable i.material-icons {
    margin: auto 0;
}

.chat-container__scrollable {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow: hidden;
}

.chat-container__arrow-btn {
    cursor: pointer;
    color: #d5d5d5;
}

.chat-container__arrow-btn:hover {
    color: #222222;
}

.chat-container__message-preview {
    text-align: left;
    border: dashed greenyellow;
    display: flex;
    flex-direction: row;
}

.message-preview__text {
    width: 80%;
}

.typing-indicator {
    background-color: #E6E7ED;
    display: flex;
    height: fit-content;
    width: auto;
    border-radius: 50px;
    padding: 5px;
    margin-left: 10px;
    margin-top: 5px;
    margin-right: 5px;
    position: relative;
    -webkit-animation: 2s bulge infinite ease-out;
            animation: 2s bulge infinite ease-out;
  }
  .typing-indicator:before, .typing-indicator:after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: -2px;
    height: 5px;
    width: 5px;
    border-radius: 50%;
    background-color: #E6E7ED;
  }
  .typing-indicator:after {
    height: 5px;
    width: 5px;
    left: -5px;
    bottom: -5px;
  }
  .typing-indicator span {
    height: 5px;
    width: 5px;
    float: left;
    margin: 0 1px;
    background-color: #9E9EA1;
    display: block;
    border-radius: 50%;
    opacity: 0.4;
  }
  .typing-indicator span:nth-of-type(1) {
    -webkit-animation: 1s blink infinite 0.3333s;
            animation: 1s blink infinite 0.3333s;
  }
  .typing-indicator span:nth-of-type(2) {
    -webkit-animation: 1s blink infinite 0.6666s;
            animation: 1s blink infinite 0.6666s;
  }
  .typing-indicator span:nth-of-type(3) {
    -webkit-animation: 1s blink infinite 0.9999s;
            animation: 1s blink infinite 0.9999s;
  }

  .disable-search {
    opacity: .3;
}

.disable-search:hover {
    opacity: .3;
}
  
  @-webkit-keyframes blink {
    50% {
      opacity: 1;
    }
  }
  
  @keyframes blink {
    50% {
      opacity: 1;
    } 
  }
  @-webkit-keyframes bulge {
    50% {
      -webkit-transform: scale(1.05);
              transform: scale(1.05);
    }
  }
  @keyframes bulge {
    50% {
      -webkit-transform: scale(1.05);
              transform: scale(1.05);
    }
  }

.chat-container__message-item-container .material-icons {
    font-family: 'Material Icons' !important;
    font-size: 20px;
    line-height: 1;
    display: block;
}

.recording__btn.hidden {
    display: none;
}

.quote-container__chat {
    margin: 1rem 33px 1rem 23px;
    color: black;
    border-radius: 4px;
    position: relative;
    display: flex;
    background-color: #26a6992d;
    align-items: center;
}

.quote-mark__container
{
    display: flex;
    align-items: start;
    height: 100%;
    padding: .3rem 5px;
    position: absolute;
}

.quote-mark {
    color: #26a69a;
    width: 5px;
}

.chat-quote-content {
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-left: 30px;
}

.chat-quote-author {
    color: #646464;
    margin-bottom: -.3rem;
}

.chat-quote-text {
    padding: .2rem;
}

.cancel-quote-icon__container {
    position: absolute;
    right: 5px;
    padding-left: 20px;
    padding-top: .5rem;
    display: flex;
    align-items: start;
    height: 100%;
}

.quote-container__chat .cancel-quote-icon {
    color: #26a69a;
    transition: scale 0.2s color 0.5s;
    transition: transform 0.2s ease-in-out;
}

.cancel-quote-icon__container:hover .cancel-quote-icon {
    color: #208b81;
    scale: 1.1;
    transform: rotate(90deg);
    transition: transform 0.4s ease-in-out;
}

.cancel-quote-icon__container:active .cancel-quote-icon {
    color: #27a89b;
    scale: 1.0;
}
`, "",{"version":3,"sources":["webpack://./src/app/chat/Chat.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;AAEJ;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gDAAgE;IAChE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gDAAqD;IACrD,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yDAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yDAA6D;IAC7D,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA,iBAAiB;;AAEjB;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,oBAAoB;IACpB,qDAAqD;AACzD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6CAA6C;YACrC,qCAAqC;EAC/C;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,UAAU;IACV,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,4CAA4C;YACpC,oCAAoC;EAC9C;EACA;IACE,4CAA4C;YACpC,oCAAoC;EAC9C;EACA;IACE,4CAA4C;YACpC,oCAAoC;EAC9C;;EAEA;IACE,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;EAEE;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;EACA;IACE;MACE,8BAA8B;cACtB,sBAAsB;IAChC;EACF;EACA;IACE;MACE,8BAA8B;cACtB,sBAAsB;IAChC;EACF;;AAEF;IACI,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,UAAU;IACV,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,UAAU;AACd","sourcesContent":[".chat-container {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #f5f5f5;\r\n    padding: 0 1rem;\r\n    position: relative;\r\n}\r\n\r\n.chat-container__message-item-container {\r\n    width: 90%;\r\n    max-width: 90%;\r\n    display: inline-block;\r\n    position: relative;\r\n}\r\n\r\n.chat-container__message-item-container * {\r\n    font-family: Gilroy !important;\r\n    font-weight: 500;\r\n}\r\n\r\n/*discard font rule for all tags inside*/\r\n.wmde-markdown * {\r\n    font-weight: revert;\r\n}\r\n\r\n.chat {\r\n    width: 98%;\r\n    height: 100%;\r\n    background: white;\r\n    overflow: auto;\r\n}\r\n\r\n.silent-chat-wrap {\r\n    width: 2.7rem;\r\n    height: 2.7rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.chat-container__opertator_text-input-container {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.chat-container__opertator_text-input-container td{\r\n    text-align: center;\r\n}\r\n\r\n.operator-text-input__table {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.operator-text-input_line td {\r\n    vertical-align: bottom;\r\n}\r\n\r\n.operator-text-input_line {\r\n    display: table-row;\r\n    vertical-align: inherit;\r\n}\r\n\r\n.operator-text-input__table tr {\r\n    border-bottom: 0rem;\r\n}\r\n\r\n.operator-text-input__table td {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.chat-container__opertator_menu {\r\n    max-height: 10rem;\r\n    word-break: break-all;\r\n    word-break: break-word;\r\n    border: 1rem solid transparent;\r\n}\r\n\r\n.chat-container__opertator_menu td{\r\n    text-align: center;\r\n    padding: 0rem;\r\n    max-width: 22rem;\r\n}\r\n\r\n.chat-container__opertator_menu tr{\r\n    border-bottom: 0rem;\r\n}\r\n\r\n.contact-avatar-container {\r\n    /* display: flex; */\r\n    position: relative;\r\n    width: 5rem;\r\n    min-width: 5rem;\r\n    vertical-align: top;\r\n}\r\n\r\n.contact-avatar-holder {\r\n    position: absolute;\r\n    top: 3.5rem;\r\n    right: 8.5rem;\r\n}\r\n\r\n.contact-item__contact-avatar {\r\n    display: block !important;\r\n    width: 3.6rem;\r\n    height: 3.6rem;\r\n    transform: none;\r\n    margin: 0;\r\n}\r\n\r\n.contact-item__contact-avatar.offline {\r\n    border: 2px solid #f00;\r\n}\r\n\r\n.contact-item__contact-avatar.online {\r\n    border: 2px solid #0f0;\r\n}\r\n\r\n.contact-name-container {\r\n    width: 30rem;\r\n    overflow: hidden;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 2;\r\n    line-clamp: 2;\r\n    margin-left:3rem;\r\n}\r\n\r\n.chat-history label {\r\n    margin-right: 3rem;\r\n}\r\n    .chat-history > div {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n.close-chat-panel-button{\r\n    right: 4rem;\r\n    top: 1.5rem;\r\n}\r\n\r\n.hide-chat-panel-button{\r\n    display: inline-block;\r\n    float: left;\r\n}\r\n\r\n.chat-header-channel-name {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.hide-chat-panel-button img {\r\n    content: url(\"../shared/images/Chat/Close_chatPanel_button.svg\");\r\n    width: 3.6rem;\r\n    border-radius: 50%;\r\n    padding: 6px;\r\n    margin-left: -0rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.hide-chat-panel-button img:hover {\r\n    padding: 6px;\r\n    border-radius: 50%;\r\n    box-shadow: 0px 0px 2px 0px #000;\r\n}\r\n\r\n.contact-avatar-link {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.contact-avatar {\r\n    border-radius: 50%;\r\n    width: 4.8rem !important;\r\n    height: 4.8rem !important;\r\n    margin-left: -2.1rem;\r\n    border: 12px solid green;\r\n}\r\n\r\n.contact-avatar svg {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.chat-name-container {\r\n    white-space: nowrap;\r\n}\r\n\r\n.chat-container__file_loader {\r\n    background-color: #fff;\r\n    font-size: small;\r\n    font-weight: 600;\r\n    margin: 0 24px;\r\n}\r\n\r\n.operator-text-input {\r\n    overflow: hidden;\r\n    resize: none;\r\n    width: 100%;\r\n    border: none;\r\n    border-bottom: #9e9e9e solid 1px;\r\n    background-color: transparent;\r\n    border-radius: 0;\r\n    outline: none;\r\n    font-size: 1.8rem !important;\r\n    margin: 0rem 0 0rem 0;\r\n    padding: 0;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    -webkit-box-sizing: content-box;\r\n    box-sizing: content-box;\r\n}\r\n\r\n.client-tags-container {\r\n    width: 30rem;\r\n}\r\n\r\n.operator-text-input__table textarea,\r\n.operator-text-input__table textarea:hover,\r\n.operator-text-input__table textarea:focus {\r\n    font-size: initial;\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n    overflow-y: auto;\r\n}\r\n\r\n.chat-container__footer{\r\n    position: relative;\r\n}\r\n\r\n.chat-footer__close-chat {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    text-transform: none;\r\n    color: #039be5;\r\n    font-size: 1.8rem;\r\n    line-height: 1.8rem;\r\n}\r\n\r\n.chat-footer__close-chat:focus {\r\n    background: none;\r\n    color: #039be5;\r\n}\r\n\r\n.chat-footer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n    font-size: 1.8rem;\r\n    column-gap: 1rem;\r\n    margin: 1rem 2rem;\r\n}\r\n\r\n.chat-footer tr {\r\n    border: none;\r\n}\r\n\r\n.chat-footer button {\r\n    cursor: pointer;\r\n}\r\n\r\n.search-answer-template-button {\r\n    position: relative;\r\n    right: -5px;\r\n    bottom: -8px;\r\n    opacity: 0.7;\r\n    font-size: 2.9rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.search-answer-template-button:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.mic-button-recording {\r\n    color: red;\r\n    position:relative;\r\n    right: 5px;\r\n    bottom: -3px;\r\n    opacity: 0.7;\r\n    font-size: 22.5px;\r\n    transition: opacity 1000ms ease-in-out;\r\n}\r\n\r\n.mic-button-recording:hover {\r\n    cursor:pointer;\r\n    opacity: 1;\r\n}\r\n\r\n.mic-button {\r\n    position: relative;\r\n    right: 5px;\r\n    bottom: -5px;\r\n    opacity: 0.7;\r\n    font-size: 2.2rem;\r\n}\r\n\r\n.mic-button:hover{\r\n    cursor:pointer;\r\n    opacity: 1;\r\n}\r\n\r\n.send-button {\r\n    content: url(\"../shared/images/Chat/send_button.svg\");\r\n    width: 3rem;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    opacity: 0.7;\r\n}\r\n\r\n.send-button:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.chat__scroll-to-up-container {\r\n    width: 3.6rem;\r\n    height: 3.6rem;\r\n    position: absolute;\r\n    top: 18rem;\r\n    right: 3.6rem;\r\n    opacity: .3;\r\n    background-color: rgb(215, 215, 215);\r\n    border-radius: 50%;\r\n}\r\n\r\n.chat__scroll-to-bottom-container {\r\n    width: 3.6rem;\r\n    height: 3.6rem;\r\n    position: absolute;\r\n    bottom: 18rem;\r\n    right: 3.6rem;\r\n    opacity: .3;\r\n    background-color: rgb(215, 215, 215);\r\n    border-radius: 50%;\r\n    z-index: 1;\r\n}\r\n\r\n.chat__scroll-to-up {\r\n    position: relative;\r\n    width: 70%;\r\n    height: 80%;\r\n    background-image: url(\"../shared/images/Chat/ScrollDown.svg\");\r\n    margin-left: 15%;\r\n    border-radius: 50%;\r\n    transform: rotate(180deg)\r\n}\r\n \r\n.chat__scroll-to-bottom {\r\n    position: relative;\r\n    width: 70%;\r\n    height: 80%;\r\n    background-image: url(\"../shared/images/Chat/ScrollDown.svg\");\r\n    margin-left: 15%;\r\n    margin-top: 15%;\r\n    border-radius: 50%;\r\n}\r\n\r\n\r\n.chat__scroll-to-bottom-container:hover {\r\n    opacity: 0.9;\r\n    cursor: pointer;\r\n}\r\n\r\n.chat__scroll-to-up-container:hover {\r\n    opacity: 0.9;\r\n    cursor: pointer;\r\n}\r\n\r\n.transfer-chat__open-operators {\r\n    background: none;\r\n    border: none;\r\n    box-shadow: none;\r\n    color: blue;\r\n    text-transform: none;\r\n    font-size: 1.8rem;\r\n    text-align: center;\r\n    width: 100%;\r\n    padding: 0;\r\n    float: left;\r\n}\r\n\r\n.transfer-chat__open-operators:hover {\r\n    background: none;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.transfer-chat__open-operators:focus {\r\n    background: none;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.chat-footer__transfer-chat {\r\n    width: 100%;\r\n}\r\n\r\n.message-params {\r\n    width: 3vh;\r\n    padding-bottom: 0.5rem !important;\r\n    padding-right: 0.5rem !important;\r\n}\r\n\r\n.chat-footer td {}\r\n\r\n.invite-operator {\r\n    float: left;\r\n}\r\n\r\n.transfer-chat__dropdown-operators {\r\n    position: absolute !important;\r\n    will-change: transform !important;\r\n    top: 10rem !important;\r\n    left: 0px !important;\r\n    transform: translate3d(116px, -286px, 0px) !important;\r\n}\r\n\r\n.transfer-chat__closed {\r\n    display: none;\r\n}\r\n\r\n.transfer-chat__dropdown-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 5.4rem;\r\n    margin: 0 0 1.8rem 0;\r\n}\r\n\r\n.transfer-chat__dropdown-operators .transfer-chat__dropdown-item:nth-of-type(odd) {\r\n    background-color: rgb(255, 255, 255, 1);\r\n}\r\n\r\n.transfer-chat__dropdown-operators .transfer-chat__dropdown-item:nth-of-type(even) {\r\n    background-color: rgba(200, 200, 200, 1);\r\n}\r\n\r\n.transfer-chat__transfer-btn {\r\n    width: 7.2rem;\r\n    height: 2.7rem;\r\n    padding: 0;\r\n    font-size: 1.8rem;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    margin: auto auto 1rem auto;\r\n    line-height: 0;\r\n}\r\n\r\n.transfer-chat__dropdown-operators .dropdown-item {\r\n    border: none;\r\n    height: 6.3rem;\r\n}\r\n\r\n.transfer-chat__dropdown-operators .dropdown-item:focus {\r\n    background-color: rgb(239, 239, 239) !important;\r\n}\r\n\r\n.transfer-chat__dropdown-operators .dropdown-item:hover {\r\n    background-color: rgb(150, 150, 150) !important;\r\n}\r\n\r\n.transfer-chat__no-online-operators {\r\n    color: black;\r\n    text-align: center;\r\n    height: 5.4rem;\r\n}\r\n\r\n.transfer-chat__search {\r\n    margin: 0 0.4rem;\r\n    margin-top: 0.2rem;\r\n}\r\n\r\n.transfer-chat__col {\r\n    padding-left: 0;\r\n    padding: 0;\r\n}\r\n\r\n.transfer-chat__dropdown-operators hr {\r\n    width: 90%;\r\n}\r\n\r\n.transfer-chat__footer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: auto;\r\n}\r\n\r\n.chat__export-chat-btn {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    text-transform: none;\r\n    color: #039be5;\r\n    font-size: 1.8rem;\r\n    line-height: 1.8rem;\r\n}\r\n\r\n.chat__export-chat-btn:focus {\r\n    background: none;\r\n    color: #039be5;\r\n}\r\n\r\n.chat-container__scrollable i.material-icons {\r\n    margin: auto 0;\r\n}\r\n\r\n.chat-container__scrollable {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.chat-container__arrow-btn {\r\n    cursor: pointer;\r\n    color: #d5d5d5;\r\n}\r\n\r\n.chat-container__arrow-btn:hover {\r\n    color: #222222;\r\n}\r\n\r\n.chat-container__message-preview {\r\n    text-align: left;\r\n    border: dashed greenyellow;\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.message-preview__text {\r\n    width: 80%;\r\n}\r\n\r\n.typing-indicator {\r\n    background-color: #E6E7ED;\r\n    display: flex;\r\n    height: fit-content;\r\n    width: auto;\r\n    border-radius: 50px;\r\n    padding: 5px;\r\n    margin-left: 10px;\r\n    margin-top: 5px;\r\n    margin-right: 5px;\r\n    position: relative;\r\n    -webkit-animation: 2s bulge infinite ease-out;\r\n            animation: 2s bulge infinite ease-out;\r\n  }\r\n  .typing-indicator:before, .typing-indicator:after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: -2px;\r\n    height: 5px;\r\n    width: 5px;\r\n    border-radius: 50%;\r\n    background-color: #E6E7ED;\r\n  }\r\n  .typing-indicator:after {\r\n    height: 5px;\r\n    width: 5px;\r\n    left: -5px;\r\n    bottom: -5px;\r\n  }\r\n  .typing-indicator span {\r\n    height: 5px;\r\n    width: 5px;\r\n    float: left;\r\n    margin: 0 1px;\r\n    background-color: #9E9EA1;\r\n    display: block;\r\n    border-radius: 50%;\r\n    opacity: 0.4;\r\n  }\r\n  .typing-indicator span:nth-of-type(1) {\r\n    -webkit-animation: 1s blink infinite 0.3333s;\r\n            animation: 1s blink infinite 0.3333s;\r\n  }\r\n  .typing-indicator span:nth-of-type(2) {\r\n    -webkit-animation: 1s blink infinite 0.6666s;\r\n            animation: 1s blink infinite 0.6666s;\r\n  }\r\n  .typing-indicator span:nth-of-type(3) {\r\n    -webkit-animation: 1s blink infinite 0.9999s;\r\n            animation: 1s blink infinite 0.9999s;\r\n  }\r\n\r\n  .disable-search {\r\n    opacity: .3;\r\n}\r\n\r\n.disable-search:hover {\r\n    opacity: .3;\r\n}\r\n  \r\n  @-webkit-keyframes blink {\r\n    50% {\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  @keyframes blink {\r\n    50% {\r\n      opacity: 1;\r\n    } \r\n  }\r\n  @-webkit-keyframes bulge {\r\n    50% {\r\n      -webkit-transform: scale(1.05);\r\n              transform: scale(1.05);\r\n    }\r\n  }\r\n  @keyframes bulge {\r\n    50% {\r\n      -webkit-transform: scale(1.05);\r\n              transform: scale(1.05);\r\n    }\r\n  }\r\n\r\n.chat-container__message-item-container .material-icons {\r\n    font-family: 'Material Icons' !important;\r\n    font-size: 20px;\r\n    line-height: 1;\r\n    display: block;\r\n}\r\n\r\n.recording__btn.hidden {\r\n    display: none;\r\n}\r\n\r\n.quote-container__chat {\r\n    margin: 1rem 33px 1rem 23px;\r\n    color: black;\r\n    border-radius: 4px;\r\n    position: relative;\r\n    display: flex;\r\n    background-color: #26a6992d;\r\n    align-items: center;\r\n}\r\n\r\n.quote-mark__container\r\n{\r\n    display: flex;\r\n    align-items: start;\r\n    height: 100%;\r\n    padding: .3rem 5px;\r\n    position: absolute;\r\n}\r\n\r\n.quote-mark {\r\n    color: #26a69a;\r\n    width: 5px;\r\n}\r\n\r\n.chat-quote-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    margin-left: 30px;\r\n}\r\n\r\n.chat-quote-author {\r\n    color: #646464;\r\n    margin-bottom: -.3rem;\r\n}\r\n\r\n.chat-quote-text {\r\n    padding: .2rem;\r\n}\r\n\r\n.cancel-quote-icon__container {\r\n    position: absolute;\r\n    right: 5px;\r\n    padding-left: 20px;\r\n    padding-top: .5rem;\r\n    display: flex;\r\n    align-items: start;\r\n    height: 100%;\r\n}\r\n\r\n.quote-container__chat .cancel-quote-icon {\r\n    color: #26a69a;\r\n    transition: scale 0.2s color 0.5s;\r\n    transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.cancel-quote-icon__container:hover .cancel-quote-icon {\r\n    color: #208b81;\r\n    scale: 1.1;\r\n    transform: rotate(90deg);\r\n    transition: transform 0.4s ease-in-out;\r\n}\r\n\r\n.cancel-quote-icon__container:active .cancel-quote-icon {\r\n    color: #27a89b;\r\n    scale: 1.0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
